import { combineReducers } from 'redux'
import { reducer as tooltip } from 'redux-tooltip';
import {
  SET_DATA_BY_COUNTRY, SET_DATA_BY_INDICATOR,
  SET_SELECTED_COUNTRY, SET_COMPARISON_COUNTRY,
  SET_SELECTED_COUNTRY_DATA, SET_COMPARISON_COUNTRY_DATA,

  LOAD_COUNTRY_DATA_LOADING, LOAD_COUNTRY_DATA_ERROR, LOAD_COUNTRY_DATA_SUCCESS, LOAD_COUNTRY_DATA_UNLOAD,
  LOAD_COMPARISON_COUNTRY_DATA_LOADING, LOAD_COMPARISON_COUNTRY_DATA_ERROR, LOAD_COMPARISON_COUNTRY_DATA_SUCCESS, LOAD_COMPARISON_COUNTRY_DATA_UNLOAD,

  OPEN_MODAL, CLOSE_MODAL,
  SET_COLOR_MODE, SET_COUNTRY_MODE,

} from '../actions'

const countriesReducer = (prevState = {}, action) => {
  return prevState
}
const indicatorsReducer = (prevState = {}, action) => {
  return prevState
}

const metaReducer = (prevState = {}, action) => {
  return prevState
}

const tfaMetaReducer = (prevState = {}, action) => {
  return prevState
}

const countriesContinentsReducer = (prevState = {}, action) => {
  return prevState
}

const modalReducer = ( prevState=false, { type }) => {
  if (type === OPEN_MODAL){
    return true
  }
  if (type === CLOSE_MODAL){
    return false
  }
  return prevState
}


const dataByCountryReducer = ( prevState={}, { type, payload }) => {
  if (type === SET_DATA_BY_COUNTRY){
    return payload
  }
  return prevState
}

const dataByIndicatorReducer = (prevState={}, {type, payload}) => {
  if (type === SET_DATA_BY_INDICATOR){
    return payload
  }
  return prevState
}

const selectedCountryReducer = (prevState=null, {type, payload}) => {
  if (type === SET_SELECTED_COUNTRY){
    return payload
  }
  return prevState
}

const comparisonCountryReducer = (prevState=null, {type, payload}) => {
  if (type === SET_COMPARISON_COUNTRY){
    return payload
  }
  return prevState
}

const selectedCountryDataReducer = ( prevState={ loading: false, data: null, error: null }, { type, payload, error }) => {
  if (type === LOAD_COUNTRY_DATA_LOADING){
    return { loading: true, data: null, error: null }
  }
  if (type === LOAD_COUNTRY_DATA_SUCCESS){
    return { loading: false, data: payload, error: null }
  }
  if (type === LOAD_COUNTRY_DATA_ERROR){
    return { loading: false, data: null, error: error }
  }
  if (type === LOAD_COUNTRY_DATA_UNLOAD){
    return { loading: false, data: null, error: null }
  }
  return prevState
}

const comparisonCountryDataReducer = (prevState={ loading: false, data: null}, {type, payload, error}) => {
  if (type === LOAD_COMPARISON_COUNTRY_DATA_LOADING){
    return { loading: true, data: null, error: null }
  }
  if (type === LOAD_COMPARISON_COUNTRY_DATA_SUCCESS){
    return { loading: false, data: payload, error: null }
  }
  if (type === LOAD_COMPARISON_COUNTRY_DATA_ERROR){
    return { loading: false, data: payload, error: error }
  }
  if (type === LOAD_COMPARISON_COUNTRY_DATA_UNLOAD){
    return { loading: false, data: null, error: null }
  }
  return prevState
}


const colorModeReducer = (prevState='performance', {type, payload}) => {
  if (type === SET_COLOR_MODE){
    return payload
  }
  return prevState
}

const countryModeReducer = ( prevState='all', {type, payload}) => {
  if (type === SET_COUNTRY_MODE){
    return payload
  }
  return prevState
}





const makePageReducer = (prefix) => {
  const innerReducer = (prevState={ loading: false, data: null}, {type, payload, error}) => {
    if (type === `${prefix}_LOADING`){
      return { loading: true, data: null, error: null }
    }
    if (type === `${prefix}_SUCCESS`){
      return { loading: false, data: payload, error: null }
    }
    if (type === `${prefix}_ERROR`){
      return { loading: false, data: null, error: error }
    }
    if (type === `${prefix}_UNLOAD`){
      return { loading: false, data: null, error: null }
    }
    return prevState
  }
  return innerReducer
}

export default combineReducers({
  countries: countriesReducer,
  indicators: indicatorsReducer,
  meta: metaReducer,
  tfaMeta: tfaMetaReducer,
  countriesContinents: countriesContinentsReducer,

  dataByCountry: dataByCountryReducer,
  dataByIndicator: dataByIndicatorReducer,

  tooltip: tooltip,
  modalOpen: modalReducer,
  //
  selectedCountry: selectedCountryReducer,
  selectedCountryData: selectedCountryDataReducer,
  comparisonCountry: comparisonCountryReducer,
  comparisonCountryData: comparisonCountryDataReducer,

  //color mode and countries selection for viz 1 and 3
  colorMode: colorModeReducer,
  countryMode: countryModeReducer,

  //pages
  countryFacilitationPolicies : makePageReducer('COUNTRY_FACILITATION'),
  thirdPillar : makePageReducer('THIRD_PILLAR'),
  sevenPillars: makePageReducer('SEVEN_PILLARS'),
  tfaArticles: makePageReducer('TFA_ARTICLES'),
  tfaProvisions: makePageReducer('TFA_PROVISIONS'),
  latestDataByIndicator: makePageReducer('LATEST_BY_INDICATOR'),

})



// WEBPACK FOOTER //
// ./src/state/reducers/index.js